<div class="flex flex-col">
  <div class="flex items-center metrics-wrapper max-width-lg mb-52">
    <div class="flex flex-row justify-between items-center">

      <!--   service metrics   -->
      <div class="flex flex-col w-100-percent">
        <div [ngClass]="{'placeholder-fade': showPlaceHolder}" class="flex flex-row items-center">
          <div *ngFor="let fullInfo of fullMetricInfos" class="flex flex-col items-center">
            <div class="mat-headline-6 mb-32" [ngClass]="{'mt-20': showPlaceHolder}">{{ fullInfo.title }}</div>
            <app-circle-progress-bar class="mb-18" [metricInfo]="fullInfo.metricInfo"></app-circle-progress-bar>
            <ng-container *ngIf="!showPlaceHolder">
              <div class="mb-18">{{ fullInfo.label }}</div>
              <button class="btn-link items-center">{{ 'PERFORMANCE_METRICS.OVERVIEW' | transloco }}
                <mat-icon svgIcon="chevron_right" class="mt-2"></mat-icon>
              </button>
            </ng-container>
          </div>
        </div>
        <ng-container *ngIf="showPlaceHolder">
          <div class="placeholder-text ml-auto mr-auto mt-20">
            {{ 'PERFORMANCE_METRICS.NO_ACTIVE_SERVICES_TEXT' | transloco }}</div>
          <div class="mat-headline-6 placeholder-subtext fw-500 mt-6 ml-auto mr-auto">
            {{ 'PERFORMANCE_METRICS.NO_ACTIVE_SERVICES_SUBTEXT' | transloco }}</div>
        </ng-container>
      </div>
      <!--  my tickets  -->
      <div Class="flex flex-col justify-between items-center justify-end my-ticket-widget white-bg">
        <div class="items-center mb-26 w-100-percent">
          <span class="mat-headline-4 mb-0">{{ 'ENTERPRISE_DASHBOARD.MY_TICKETS' | transloco }}</span>
          <mat-icon svgIcon="filter_alt" class="ml-auto mt-10"></mat-icon>
        </div>
        <app-support-ticket *ngFor="let ticket of recentTickets let last = last"
                            [ticket]="ticket"
                            [ngClass]="{'mb-32': last}"
                            class="mb-8">
        </app-support-ticket>
        <div class="flex flex-col items-center mt-60 mb-auto" *ngIf="recentTickets.length === 0">
          <img src="/assets/images/Group 3925.svg">
          <div class="mb-0 mt-8 mat-subtitle-2 placeholder-fade">
            {{ 'ENTERPRISE_DASHBOARD.NO_TICKETS_FOUND' | transloco }}</div>
        </div>
        <span class="flex-auto"></span>
        <div class="flex flex-row justify-between items-center w-100-percent">
          <button class="flex items-center btn-link mt-6"
                  [ngClass]="{'placeholder-fade': recentTickets.length === 0}">{{ 'ENTERPRISE_DASHBOARD.ALL_TICKETS' | transloco }}
            <mat-icon svgIcon="arrow_upward" class="mt-2"></mat-icon>
          </button>

          <button class="items-center accent">
            <mat-icon svgIcon="add" class="icon-md mt-2 mr-2"></mat-icon>
            {{ 'ENTERPRISE_DASHBOARD.NEW_TICKET' | transloco }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-my-services [showTitle]="true"></app-my-services>

</div>
